@if(showButtons){
<div class="approve-decline" [ngClass]="{ dim: isInactive }">
	<div
		class="approve-decline-inner"
		[ngClass]="{
			approved: status === statuses.Approved,
			declined: status === statuses.Declined,
		}"
	>
		<div class="buttons">
			<div
				class="button-decline"
				[ngClass]="{
					approved: status === statuses.Approved,
					declined: status === statuses.Declined,
				}"
				(click)="declineProperty()"
			>
				@if(status !== statuses.Declined){ @if(status !==
				statuses.Approved){
				<img src="/assets/update/ic-close-18px-dark.svg" />} @else {
				<img src="/assets/update/ic-close-18px-slate.svg" />}
				<div
					class="button-text-decline"
					[ngClass]="{ approved: status === statuses.Approved }"
				>
					{{ Loc(LocalizedTextIds.Decline) }}
				</div>
				} @if(status === statuses.Declined){
				<div class="button-text-decline declined">
					{{ Loc(LocalizedTextIds.Declined) }}
				</div>
				}
			</div>
			<div
				class="button-approve"
				[ngClass]="{
					approved: status === statuses.Approved,
					declined: status === statuses.Declined,
				}"
				(click)="approveProperty()"
			>
				@if(status !== statuses.Approved) { @if(status ===
				statuses.Pending) {
				<img src="/assets/update/ic-check-18px-green.svg" />} @if(status
				=== statuses.Declined){
				<img src="/assets/update/ic-check-18px-grey.svg" /> }
				<div
					class="button-text-approve"
					[ngClass]="{ declined: status === statuses.Declined }"
				>
					{{ Loc(LocalizedTextIds.Approve) }}
				</div>
				} @if(status === statuses.Approved){
				<div class="button-text-approve approved">
					{{ Loc(LocalizedTextIds.Approved) }}
				</div>
				}
			</div>
		</div>
	</div>
</div>
}
